export default __webpack_public_path__ + "assets/91284ebfe0c19204884e98b4dc24efb4.svg";